var discountsOffset = 0;

window.isFutureDiscountAvailable = content => {
    var discountsCount = 9;
    var goodsCount = content.split('js-good').length - 1;

    if (goodsCount < 1 || goodsCount < discountsCount) {
        // Don't expect future data, hide button
        $('.js-discounts-more').hide();

        // Reset offset, so when button is restored, it counts correctly
        discountsOffset = 0;
    }
};

$(document).on('click', '.js-discounts-more', function (ev) {
    ev.preventDefault();

    var prevText = $(this).text();
    $(this).html('<img src="/images/gear.svg">');
    $(this).css('pointer-events', 'none');

    var resetBtn = function () {
        that.text(prevText);
        that.css('pointer-events', 'auto');
    };

    discountsOffset++;

    var that = $(this);
    $.post('/index/load-discounts/', {offset: discountsOffset}, function (response) {
        resetBtn();

        if (!response) {
            // No more data
            that.hide();

            // Reset offset, so when button is restored, it counts correctly
            discountsOffset = 0;
            return;
        }

        isFutureDiscountAvailable(response);
        $('#mainDiscounts').append(response);
    }).fail(function () {
        resetBtn();
    });
});

var newGoodsOffset = 0;

$(document).on('click', '.js-new-goods-more', function (ev) {
    ev.preventDefault();

    var prevText = $(this).text();
    $(this).html('<img src="/images/gear.svg">');
    $(this).css('pointer-events', 'none');

    var resetBtn = function () {
        that.text(prevText);
        that.css('pointer-events', 'auto');
    };

    newGoodsOffset++;

    var that = $(this);
    $.post('/index/load-new-goods/', {offset: newGoodsOffset}, function (response) {
        resetBtn();

        if (!response) {
            // No more data
            that.hide();

            // Reset offset, so when button is restored, it counts correctly
            newGoodsOffset = 0;
            return;
        }

        $('#mainNew').append(response);
    }).fail(function () {
        resetBtn();
    });
});

var hitsGoodsOffset = 0;

$(document).on('click', '.js-hits-goods-more', function (ev) {
    ev.preventDefault();

    var prevText = $(this).text();
    $(this).html('<img src="/images/gear.svg">');
    $(this).css('pointer-events', 'none');

    var resetBtn = function () {
        that.text(prevText);
        that.css('pointer-events', 'auto');
    };

    hitsGoodsOffset++;

    var that = $(this);
    $.post('/index/load-hits-goods/', {offset: hitsGoodsOffset}, function (response) {
        resetBtn();

        if (!response) {
            // No more data
            that.hide();

            // Reset offset, so when button is restored, it counts correctly
            hitsGoodsOffset = 0;
            return;
        }

        $('#mainTop').append(response);
    }).fail(function () {
        resetBtn();
    });
});

var souvenirGoodsOffset = 0;

$(document).on('click', '.js-souvenirs-more', function (ev) {
    ev.preventDefault();

    var prevText = $(this).text();
    $(this).html('<img src="/images/gear.svg">');
    $(this).css('pointer-events', 'none');

    var resetBtn = function () {
        that.text(prevText);
        that.css('pointer-events', 'auto');
    };

    souvenirGoodsOffset++;

    var that = $(this);
    $.post('/index/load-souvenirs/', {offset: souvenirGoodsOffset}, function (response) {
        resetBtn();

        if (!response) {
            // No more data
            that.hide();

            // Reset offset, so when button is restored, it counts correctly
            souvenirGoodsOffset = 0;
            return;
        }

        $('#mainSouvenirs').append(response);
    }).fail(function () {
        resetBtn();
    });
});
